module.exports = __webpack_public_path__ + "img/caseReport_top.872f642d.png";